const getMonthName = (months = [], month) => months.find(({ id }) => id === Number(month))?.name;

export default getMonthName;
